'use strict';

import Fuse from 'fuse.js';
import throttle from 'raf-throttle';

export default function($){
    ////////////////////////////////////
    ////////////////////////////////////
    // App
    ////////////////////////////////////
    ////////////////////////////////////
    var ngListApp = angular.module("ngListApp", ["ngRoute"]);
    ////////////////////////////////////

    ////////////////////////////////////
    ////////////////////////////////////
    // Services
    ////////////////////////////////////
	////////////////////////////////////

    // NEW: Get Query string value by name
    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

	//Disable IE caching
	ngListApp.config([
		"$httpProvider", "$locationProvider",
		function ($httpProvider, $locationProvider, $httpParamSerializerProvider) {
			// Initialize get if not there
			if (!$httpProvider.defaults.headers.get) {
				$httpProvider.defaults.headers.get = {};
			}
			// Disable IE ajax request caching
			$httpProvider.defaults.headers.get["If-Modified-Since"] = "0";

			if (window.history && window.history.pushState) {
				$locationProvider.html5Mode({
					enabled: true,
					requireBase: false
				});
			}
			else {
				window.location.hash = "/";  // IE 9 FIX
				$locationProvider.html5Mode({
					enabled: false,
					requireBase: false
				});
			}
		}
	]);

    // Broadcast
    ngListApp.factory("broadcastService", ["$rootScope", function($rootScope){
        return {
            broadcast: function(name, args) {
                $rootScope.$broadcast(name, args);
            }
        }
    }]);
    // HTTP
    ngListApp.factory("httpService", ["$http", "broadcastService", function($http, broadcastService){
        return {
            get:function(url) {
                $http.get(url)
                    .then(function(r){
                        broadcastService.broadcast("AJAX-RETURN", {data: r});
                    });
            }
        };
    }]);
    // Http Ctrl
    ngListApp.factory("httpServiceCtrl", ["httpService", function(httpService){
        return {
            // Can split up different pages/api urls
            searchResults:function(type, term, page, filter, searchTerm,culture, country){
				var search = "";

				if(type !== 'agent'){
					if(type === 'search'){
						search = ("?term=" + term + "&page=" + page)
					}
					else if(type=== 'blogs'){
						search = `?category=${term}&searchTerm=${searchTerm}&page=${page}&filter=${filter}`;
					}
					else{
						search = (term !== "all" || country !=="all" ? "?category=" + (term !== "all" ? term || "" : "") + "&country=" + (country !== "all" ? country || "" : "") + "&page=" + page : "?page=" + page);
                    }

                    if(culture !== "undefined")
                    {
                        search = search + "&culturecode=" + culture;
                    }

                    var pathElement = document.getElementById("hdnPath");
                    if(typeof(pathElement) != 'undefined' && pathElement != null)
                    {
                        search = search + "&path=" +  pathElement.value;
                    }
				}

                if(type === 'agent/all') {
                    search = `?category=${term ? term : 'undefined'}&page=${page ? page : "undefined"}${culture !== "undefined" ? "&culturecode=" + culture : "undefined"}`;
                    var pathElement = document.getElementById("hdnPath");
                    if(typeof(pathElement) != 'undefined' && pathElement != null)
                    {
                        search = search + "&path=" +  pathElement.value;
                    }
                }

	           	const url = "/api/"+type+search;
                httpService.get(url);
            }
        }
    }])
	////////////////////////////////////

	ngListApp.directive('ngOverflownTags', ['$window', ($window) =>{
		return{
			scope:{
				ngOverflownTags: '='
			},
			link($scope, $el, attrs){
				const updateFilterInnerOverflowStatus = () => {
					const $filterInner = $el.not('.is-wrapped').find('.c-blogs__filter-inner');
					if($filterInner.length){
						if($filterInner[0].scrollWidth - 5 > $filterInner[0].offsetWidth){
							$el.addClass('is-overflown');
						} else{
							$el.removeClass('is-overflown');
						}
					}
				};
				const throttledFn= throttle(updateFilterInnerOverflowStatus);

				updateFilterInnerOverflowStatus();

				$scope.$on('AJAX-RETURN', throttledFn);

				angular.element($window).on('resize', throttledFn);
			}
		}
	}])

	ngListApp.directive("onFinishRender", ['$timeout', ($timeout) =>{
		return {
			restrict: "A",
			link: function (scope, element, attr) {
				if (scope.$last === true) {
					$timeout(function () {
						scope.$emit(attr.onFinishRender);
					});
				}
			}
		};
	}]);

	ngListApp.filter('unsafe', ['$sce', ($sce) => { return $sce.trustAsHtml; }]);

    ////////////////////////////////////
    ////////////////////////////////////
    // Controllers
    ////////////////////////////////////
    ////////////////////////////////////
    // Events, Search, Blog, Scholarships
    ngListApp.controller("ngListCtrl", ["$scope", "broadcastService", "httpServiceCtrl", function($scope, broadcastService, httpServiceCtrl){

        ////////////////////////////////////
        // Data
        ////////////////////////////////////
        // Type of search
        $scope.type = $('[ng-list-container]').data('page-type');

        // Cheating for scrolling to top
        $scope.hasRun = false;

        // getting search data
        $scope.searchString = "";

        // search complete
        $scope.data = {};

        // Global data for current search
        $scope.maxPages = 1;
        $scope.totalItemCount = 1;
        $scope.pageItemSize = 1;
        $scope.categories = [];
        $scope.countries = [];
		$scope.ShowCountriesFilter = false;

        // tracking current progress
        $scope.searchRunning = true;
        $scope.currentPage = 1;
		$scope.currentCategory = 'all';
		$scope.currentCountry = 'all';
        $scope.currentPageItemsStart = 1;
        $scope.currentPageItemsEnd = 1;
        $scope.atStart = true;
        $scope.atEnd = false;
		$scope.showPagination = false;

		// Blog only
		$scope.isTagFilterOverflown = false;
		$scope.isTagFilterMobileOverflown = false;

        // Utilities
        $scope.getNumber = function(num) {
            var array = [];

            for (var i = 0, leng = num; i < leng; i++) {
                var a = i + 1;
                array.push(a);
            }

            return array;
        };
        $scope.range = function() {
            var rangeSize = $scope.maxPages > 5 ? 5 : Math.ceil($scope.totalItemCount / $scope.pageItemSize);
            var ps = [];
            var start;
            start = $scope.currentPage;
            if ($scope.currentPage > 1) {
                if ( start > $scope.maxPages-rangeSize ) {
                    start = $scope.maxPages-rangeSize+1
                } else {
                    start = $scope.currentPage - 1;
                }
            }
            for (var i=start; i<start+rangeSize; i++) {
                ps.push(i);
            }
            return ps;
        };
        $scope.getDate = function(date){
            var $date = date.split(' ');
            return new Date(parseInt($date[2]),parseInt($date[1]-1),parseInt($date[0]));
		};

        ////////////////////////////////////
        // Listeners
        ////////////////////////////////////
        $scope.$on("AJAX-RETURN", function(e, arg){

            // Put data aside
            $scope.data = $scope.type==="search"? arg.data.data : arg.data.data[$scope.type.charAt(0).toUpperCase() + $scope.type.slice(1)];
            $scope.pageItemSize = $scope.data ? $scope.data.PageSize : 0;
            $scope.totalItemCount = $scope.data ? $scope.data.TotalCount : 0;
            $scope.maxPages = $scope.data ? Math.ceil($scope.totalItemCount / $scope.pageItemSize) : 0;
			$scope.categories = typeof arg.data.data.Categories !== "undefined" ? arg.data.data.Categories : [];
			$scope.countries = typeof arg.data.data.Countries !== "undefined" ? arg.data.data.Countries : [];
			$scope.ShowCountriesFilter = typeof arg.data.data !== "undefined" ? arg.data.data.ShowCountriesFilter : false;
            $scope.currentPageItemsStart = ($scope.currentPage <= 1) ? 1 : ($scope.pageItemSize * ($scope.currentPage - 1) + 1);
            $scope.currentPageItemsEnd = ($scope.pageItemSize * $scope.currentPage) > $scope.totalItemCount ? $scope.totalItemCount : $scope.pageItemSize * $scope.currentPage;
            $scope.searchRunning = false;
            $scope.showPagination = ($scope.pageItemSize <= $scope.totalItemCount) ? false : true;

            // Scroll to top, but only if has already run at least once, so it doesnt scroll on initial load
            if ($scope.hasRun) {
                $('html, body').animate({
                    scrollTop: $("[ng-list-container]").offset().top + 'px'
                }, 500);
            };
            $scope.hasRun = true;

        });
        $scope.$on("SCOPE-APPLY", function(e, arg){
        });

        ////////////////////////////////////
        // Funcs
        ////////////////////////////////////
        function getData() {
            var search = window.location.search.replace('?', '').split('&'),
                term = $scope.type === "search" ? search[0].substr(search[0].indexOf('=') + 1) : $scope.currentCategory;
                var culture = $("#hdnDocumentCulture").val();
            httpServiceCtrl.searchResults($scope.type, term, $scope.currentPage,"","",culture, $scope.currentCountry);
		};

        function pagination(direction) {
            if (direction === "prev") {
                if ($scope.currentPage > 1) {
                    $scope.searchRunning = true;
                    $scope.currentPage--;
                    getData();
                }
            } else if (direction === "next") {
                if ($scope.currentPageItemsEnd < $scope.data.TotalCount) {
                    $scope.searchRunning = true;
                    $scope.currentPage++;
                    getData();
                }
            } else {
                $scope.searchRunning = true;
                $scope.currentPage = direction;
                getData();
            }
        };
        function changeTopic(topic) {
            // Change topic button text
            $('#select-topic').text(topic);

            // Load new topic data
            $scope.searchRunning = true;
            $scope.currentPage = 1;
            $scope.currentCategory = topic;
            getData();
		}

		// NEW FUNCTION TODO
		function changeCountry(country) {
			// Change topic button text
			$('#select-topic-country').text(country);

			// Load new topic data
			$scope.searchRunning = true;
			$scope.currentPage = 1;
			// $scope.currentCategory = topic;
			$scope.currentCountry = country;

			//Reset category on country change
			$scope.currentCategory = '';
			$('#select-list-topic').val('All')

			getData();
		}
        ///////////////

        $(document)
            .ready(function(){
                getData();
            })
            .on('click', '[pagination-button]', function(){
                pagination($(this).data("pagination"));
            })
            .on('change', '[topic-select-field]', function(){
                changeTopic($(this).val().toLowerCase());
            })
            .on('change', '[country-select-field]', function(){
                changeCountry($(this).val().toLowerCase());
            });
	}]);

	ngListApp.controller("ngBlogListCtrl", ["$scope", "broadcastService", "httpServiceCtrl", "$location", function ($scope, broadcastService, httpServiceCtrl, $location) {
		////////////////////////////////////
		// Data
		////////////////////////////////////
		// Type of search
		$scope.type = $('[ng-list-container]').data('page-type');

		// getting search data
		$scope.searchString = "";

		// search complete
		$scope.data = {};
		$scope.featuredBlogs = [];

		// Global data for current search
		$scope.maxPages = 1;
		$scope.totalItemCount = 1;
		$scope.pageItemSize = 1;
		$scope.categories = [];

		// tracking current progress
		$scope.searchRunning = true;
		$scope.currentPage = 1;
		$scope.currentCategory = {
			name: ''
		};
		$scope.currentCountry = {
			name: ''
		};
		$scope.sort= {
			name: ''
		};
		$scope.searchTerm= '';
		$scope.prevSearchTerm = '';

		// Blog only
		$scope.isTagFilterOverflown = false;
		$scope.isTagFilterMobileOverflown = false;

		 $scope.getValueByKey = function (keyValue) {
			var value = $location.search()[keyValue];
			if (value === undefined) {
				return null;
			}
			return value;
		}

		$scope.resetFilter = function(){
			$scope.searchTerm = '';
			$scope.prevSearchTerm = '';
			$scope.currentCategory.name= '';
			$scope.currentCountry.name= '';
			$scope.sort.name= '';
			$location.search("tag", $scope.currentCategory.name);
			$location.search("sort", $scope.sort.name);
			$location.search("searchTerm", '');
			$scope.changeFilter();
		}
		$scope.changeFilter = function () {
			$scope.data = {};
			$scope.searchRunning = true;
			$scope.currentPage = 1;

			$location.search("tag", $scope.currentCategory.name);
			$location.search("sort", $scope.sort.name);
			getData();
		}

		$scope.changeTag = function(val){
			$scope.currentCategory.name = val;
			$scope.changeFilter();
		}

		$scope.changeSearchTerm = function(){
			if($scope.prevSearchTerm !== $scope.searchTerm){
				$scope.prevSearchTerm = angular.copy($scope.searchTerm);
				$location.search("q", $scope.searchTerm);
				getData();
			}
		}
		$scope.loadMore = function(){
			$scope.isLoadingMore = true;
			$scope.currentPage++;
			getData();
		}

		////////////////////////////////////
		// Listeners
		////////////////////////////////////
		$scope.$on("AJAX-RETURN", function (e, arg) {
			// console.log(">> AJAX-RETURN BROADCAST");
			$scope.searchRunning = false;


			// Put data aside
			const data = arg.data.data[$scope.type.charAt(0).toUpperCase() + $scope.type.slice(1)];
			if($scope.isLoadingMore){
				$scope.data = {
					...data,
					Results: [...$scope.data.Results, ...data.Results]
				}
			} else{
				$scope.data = data;
			}
			$scope.pageItemSize = $scope.data ? $scope.data.PageSize : 0;
			$scope.totalItemCount = $scope.data ? $scope.data.TotalCount : 0;
			$scope.maxPages = $scope.data ? Math.ceil($scope.totalItemCount / $scope.pageItemSize) : 0;
			$scope.categories = typeof arg.data.data.Categories !== "undefined" ? arg.data.data.Categories : [];
			if (arg.data.data.FeaturedBlogs && arg.data.data.FeaturedBlogs && arg.data.data.FeaturedBlogs.length && !$scope.featuredBlogs.length) {
				$scope.featuredBlogs = arg.data.data.FeaturedBlogs;
			}
			$scope.currentPageItemsStart = ($scope.currentPage <= 1) ? 1 : ($scope.pageItemSize * ($scope.currentPage - 1) + 1);
			$scope.currentPageItemsEnd = ($scope.pageItemSize * $scope.currentPage) > $scope.totalItemCount ? $scope.totalItemCount : $scope.pageItemSize * $scope.currentPage;
			$scope.showPagination = ($scope.pageItemSize <= $scope.totalItemCount) ? false : true;

			$scope.isLoadingMore = false;
			$scope.hasRun = true;

		});

		$scope.$on('repeatFinished', function(){
			DISQUSWIDGETS.getCount({reset: true});
		})


		////////////////////////////////////
		// Funcs
		////////////////////////////////////
		function getData() {
			// console.log(">> RUNNING GET DATA");
			var search = window.location.search.replace('?', '').split('&');
			httpServiceCtrl.searchResults($scope.type, $scope.currentCategory.name || '', $scope.currentPage, $scope.sort.name || '', $scope.searchTerm);
		};

		$(document)
			.ready(function () {
				$scope.currentCategory.name = $scope.getValueByKey("tag") || $scope.currentCategory.name;
				$scope.sort.name = $scope.getValueByKey("sort") || $scope.sort.name;
				$scope.searchTerm = $scope.getValueByKey("q") || $scope.searchTerm;
				getData();
			})

	}])


    // Agent Search
    ngListApp.controller("ngAgentSearchCtrl", ["$scope", "broadcastService", "httpServiceCtrl", "$rootScope", "$timeout", "$filter", function($scope, broadcastService, httpServiceCtrl, $rootScope, $timeout, $filter){
        // console.log(">> >> NG-AGENT-SEARCH CTRL");
        ////////////////////////////////////
        // Data
        ////////////////////////////////////
        // Type of search
        $scope.type = $('[ng-list-container]').data('page-type');

        // Cheating for scrolling to top
        $scope.hasRun = false;

        // search complete
        $scope.dataMaster = {};

        // Filter complete
        $scope.dataFilter = {};

        // Paginated data
        $scope.data = {};

        // Global data for current search
        $scope.maxPages = 1;

        // tracking current progress
        $scope.searchRunning = true;
        $scope.currentPage = 1;
        $scope.currentPageItemsStart = 1;
        $scope.currentPageItemsEnd = 1;
        $scope.totalItemCount = 1;
        $scope.pageItemSize = 1;
        $scope.atStart = true;
        $scope.atEnd = false;
        $scope.showPagination = false;
        $scope.countryFilterKey = false;
		$scope.searchStringKey = false;
	    $scope.suburbs = [];

        // Utilities
        $scope.range = function() {
            var rangeSize = $scope.maxPages > 5 ? 5 : Math.ceil($scope.dataFilter.length / $scope.pageItemSize);
            var ps = [];
            var start;
            start = $scope.currentPage;
            if ($scope.currentPage > 1) {
                if ( start > $scope.maxPages-rangeSize ) {
                    start = $scope.maxPages-rangeSize+1
                } else {
                    start = $scope.currentPage - 1;
                }
            }
            for (var i=start; i<start+rangeSize; i++) {
                ps.push(i);
            }
            return ps;
        };
        $scope.resetFilter = function() {
            // Reset data keys
            $scope.countryFilterKey = false;
            $scope.searchStringKey = false;
            $scope.currentPageItemsStart = 1;
            $scope.currentPage = 1;

            // Update to scrolling doesnt happen
            $scope.hasRun = false;

            // Reset Fields
            $('[agent-search-keyword]').val('')
            $('[agent-search-country-select]').val($('[agent-search-country-select]').find('option:first-child').val());

            // Trigger re render/re filter
            $scope.dataFiltering();
        };
        // Filters
        $scope.keywordFilter = function(dataSet) {
            var options = {
                shouldSort: false,
                threshold: 0.2,
                location: 0,
                distance: 100,
                maxPatternLength: 32,
                minMatchCharLength: 1,
                keys:[
                    {
                        name: 'AgentName',
                        weight: 0.9
                    }, {
                        name: 'Address',
                        weight: 0.8
                    }, {
                        name: 'Country',
                        weight: 0.7
                    }, {
                        name: 'AgentCode',
                        weight: 0.6
                    }, {
                        name: 'Email',
                        weight: 0.5
                    }, {
                        name: 'Phone',
                        weight: 0.4
                    }
                ]
                };
              var fuse = new Fuse(dataSet, options); // "list" is the item array
              var result = fuse.search($scope.searchStringKey);
            //   console.log(result);
              return result;
        };
        $scope.countryFilter = function(dataSet) {

            var result = dataSet.filter(item => {

                var rawCountry = item.Country.toLowerCase().replace('the ', '');
                const compareCountry = rawCountry.replace(/([\s-_/(/)])/g, '').toLowerCase();
                const filterString = $scope.countryFilterKey.replace(/([\s-_/(/)])/g, '').toLowerCase();
                return compareCountry.includes(filterString)
            });

            if(result.length === 0) {
                var options = {
                    shouldSort: false,
                    threshold: 0,
                    location: 0,
                    distance: 100,
                    maxPatternLength: 32,
                    minMatchCharLength: 1,
                    keys: [
                      "Country"
                    ]
                };

                var fuse = new Fuse(dataSet, options); // "list" is the item array
                result = fuse.search($scope.countryFilterKey);
            }

	        $scope.suburbs = result.map(item => item.Suburb).filter((value, index, self) => self.indexOf(value) === index && value !== "");

			if ($scope.suburbFilterKey != null && $scope.suburbFilterKey !== "") {
				result = result.filter(item => item.Suburb == $scope.suburbFilterKey);
			}

            return result;
		};
		$scope.suburbFilter = function () {
			$scope.hasRun = false;
			$scope.dataFiltering();
		}

        $scope.alphabeticalFilter = function(dataSet, orderBy) {
            $filter('orderBy')(dataSet, orderBy, false);
            return dataSet;
        };
        // Control the data filtering
        $scope.dataFiltering = function(keyword){

            // Set up data
            var $tempArray = JSON.parse(JSON.stringify($scope.dataMaster));

            // Country and keyword
            if (!!scope.countryFilterKey && !!scope.searchStringKey) {
                $tempArray = $scope.countryFilter($tempArray);
                $tempArray = $scope.keywordFilter($tempArray);
            }
            // Country only
            else if (!!scope.countryFilterKey && !scope.searchStringKey) {
                $tempArray = $scope.countryFilter($tempArray);
               // $tempArray = $scope.alphabeticalFilter($tempArray, "AgentName");
            }
            // Keyword only
            else if (!scope.countryFilterKey && !!scope.searchStringKey) {
                $tempArray = $scope.keywordFilter($tempArray);
            }
            // Neither, is a reset
            else if (!scope.countryFilterKey && !scope.searchStringKey) {
                // $scope.dataFilter = JSON.parse(JSON.stringify($tempArray));
            };

            // Update Filtered Data
            $scope.dataFilter = JSON.parse(JSON.stringify($tempArray));

            // Update counts
            $scope.totalItemCount = $scope.dataFilter.length;
            $scope.maxPages = Math.ceil($scope.totalItemCount / $scope.pageItemSize);
            if ($scope.totalItemCount <= $scope.pageItemSize) {
                $scope.currentPageItemsEnd = $scope.totalItemCount;
                $scope.showPagination = true;
            } else {
                $scope.currentPageItemsEnd = ($scope.pageItemSize * $scope.currentPage) > $scope.totalItemCount ? $scope.totalItemCount : $scope.pageItemSize * $scope.currentPage;
                $scope.showPagination = false;
            }

            // Re run pagination
            $scope.dataPagination();
        }
        // Cut up the master data to into a nice chunk
        $scope.dataPagination = function() {
            $scope.data = $scope.dataFilter.slice($scope.currentPageItemsStart - 1, $scope.currentPageItemsEnd);

            $scope.searchRunning = false;
            $rootScope.$broadcast("SCOPE-APPLY", false);

            // Scroll to top, but only if has already run at least once, so it doesnt scroll on initial load
            if ($scope.hasRun) {
                $('html, body').animate({
                    scrollTop: $("[ng-list-container]").offset().top + 'px'
                }, 500);
            };
            $scope.hasRun = true;
        };
        // $scope.getDate = function(date){
        //     var $date = date.split(' ');
        //     return new Date($date[2],$date[1],$date[0]);
        // };

        ////////////////////////////////////
        // Listeners
        ////////////////////////////////////
        $scope.$on("AJAX-RETURN", function(e, arg){
            // console.log(">> AJAX-RETURN BROADCAST");
            // Put data aside
            $scope.dataMaster = arg.data.data;
            $scope.dataFilter = arg.data.data;
            $scope.pageItemSize = 10;
            $scope.totalItemCount = $scope.dataMaster.length;
            $scope.maxPages = Math.ceil($scope.totalItemCount / $scope.pageItemSize);
            $scope.currentPageItemsStart = ($scope.currentPage <= 1) ? 1 : ($scope.pageItemSize * ($scope.currentPage - 1) + 1);
            $scope.currentPageItemsEnd = ($scope.pageItemSize * $scope.currentPage) > $scope.totalItemCount ? $scope.totalItemCount : $scope.pageItemSize * $scope.currentPage;
            $scope.searchRunning = false;
            $scope.showPagination = ($scope.pageItemSize <= $scope.totalItemCount) ? false : true;
            $scope.dataFiltering();
        });
        $scope.$on("SCOPE-APPLY", function(e, arg){
            // console.log(">> SCOPE-APPLY CALLED");
            $timeout(function() {
                // anything you want can go here and will safely be run on the next digest.
                $scope.$apply();
            })
		});

        ////////////////////////////////////
        // Funcs
        ////////////////////////////////////
        function getData() {
            httpServiceCtrl.searchResults($scope.type + "/all");
        };
        function pagination(direction) {
            // console.log(">> INSIDE CHANGING PAGINATION");

            // Update and show loading
            if (direction === "prev") {
                if ($scope.currentPage > 1) {
                    $scope.currentPage--;
                }
            } else if (direction === "next") {
                if ($scope.currentPageItemsEnd < $scope.totalItemCount) {
                    $scope.currentPage++;
                }
            } else {
                $scope.currentPage = direction;
            }

            $scope.currentPageItemsStart = ($scope.currentPage <= 1) ? 1 : ($scope.pageItemSize * ($scope.currentPage - 1) + 1);
            $scope.currentPageItemsEnd = ($scope.pageItemSize * $scope.currentPage) > $scope.totalItemCount ? $scope.totalItemCount : $scope.pageItemSize * $scope.currentPage;

            // Trigger data filter
            // console.log(">> //////////////////////////////////////////");
            // console.log(">> >> PAGINATION TRIGGER DATA PAGINATION");

            $scope.dataPagination();
        };
        ///////////////
        window.scope = $scope;

        $(document)
			.ready(function () {

				// Set default country in dropdown
				var $cookie = Cookies.get("currentCountry");
				if (typeof $cookie !== "undefined") {
					if ($cookie === "Australia2") {
                        $('[agent-search-country-select]').val($('[agent-search-country-select] option[value="Australia"]').val());
                        $scope.countryFilterKey = "Australia";
					} else if ($cookie !== "Australia1") {
                        $('[agent-search-country-select]').val($('[agent-search-country-select] option[value="' + $cookie +'"]').val());
                        $scope.countryFilterKey = $cookie;
                    };
                } else {

                }

                // overwrite country and stuff if its in the url
                function getParameterByName(name, url) {
                    if (!url) url = window.location.href;
                    name = name.replace(/[\[\]]/g, "\\$&");
                    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                        results = regex.exec(url);
                    if (!results) return null;
                    if (!results[2]) return '';
                    return decodeURIComponent(results[2].replace(/\+/g, " "));
                }
                var a = getParameterByName('country', window.location.search);
                if (a !== null && a !== "") {
                    $('[agent-search-country-select] option').each(function () {
                        if ($(this).attr('value').toLowerCase() === a.toLowerCase()) {
                            $scope.countryFilterKey = $(this).val();
                            $('[agent-search-country-select]').val($(this).val());
                            Cookies.set("currentCountry", $(this).val(), { expires: 365 });
                        };
                    })
                }

                getData();
            })
            .on('click', '[pagination-button]', function(){
                pagination($(this).data("pagination"));
            })
            .on('click', '.button.reset', function(){
                $scope.resetFilter();
            })
            .on('change', '[agent-search-country-select]', function(){
                var $val = $(this).val();
                console.log($val)
                if ($val === "all") {
                    $scope.countryFilterKey = false;
                } else {
                    $scope.countryFilterKey = $val;
                }

                // Update to scrolling doesnt happen
                $scope.hasRun = false;

                // Go to page 1
                $scope.currentPageItemsStart = 1;
                $scope.currentPage = 1;
		        $scope.suburbFilterKey = null;
		        $scope.dataFiltering();
	        })
            .on('keyup', '[agent-search-keyword]', function(){
                var $val = $(this).val();

                if ($val.length > 2 && $val !== "") {
                    $scope.searchStringKey = $val;
                }
                // if blank
                else if ($val === "" || $val === " ") {
                    $scope.searchStringKey = false;
                };

                // Update to scrolling doesnt happen
                $scope.hasRun = false;

                // Go to page 1
                $scope.currentPageItemsStart = 1;
				$scope.currentPage = 1;
                $scope.dataFiltering();
            });

    }]);
    ////////////////////////////////////
};

// Alphabetical search filtering



// WEBPACK FOOTER //
// ./src/_js/partials/ng-listing.js